import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MainHeader } from '../MainHeader';
import { PhotoCollection } from '../PhotoCollection';
import { images } from './images';
import './styles.css';

export const Lobola = () => {
  useEffect(() => {
    document.title = "Rue's Events Designs - Lobola";
  }, []);

  return (
    <div className="collection-page">
      <MainHeader home={false} about={false} gallery={true} contact={false} />
      <section className="collection-hero">
        <p className="section-kicker">Rue's Events gallery</p>
        <h1>Lobola</h1>
        <p>Traditional celebrations thoughtfully styled to honour family, culture and the significance of the occasion.</p>
        <div className="collection-back-link">
          <Link to="/gallery">← Back to all collections</Link>
        </div>
      </section>
      <div className="collection-gallery-shell">
        <PhotoCollection images={images} label="Lobola" />
      </div>
    </div>
  );
};
